export enum ProductSectionsEnum {
    core, saleChannel, info, suppliers, dimensions, text, photos, video, documents
}